import React from 'react';
import ChipLinkButton from '../ChipLinkButton';

const ProductActions = ({ actionsList }) => (
  <>
    {actionsList.map(actionProps => (
      <ChipLinkButton {...actionProps} />
    ))}
  </>
);

export default ProductActions;
